<div class="app-body">
    <main class="main">
        <div class="release-template">
            <div class="release-template-wrapper">
                <div class="releaseEmailHeader">
                    <div class="releaseEmaillogo">
                        <img alt="AutoLeap" class="img-fluid" src="../../../../assets/autoleap-logo.png" />
                    </div>
                </div>

                <div class="releaseEmailBody">
                    <div class="sectionHeader">
                        <h4>AutoLeap Release Notes <span> Oct 20, 2020 </span></h4>

                        <div class="wideBanner my-4"><img alt="" src="../../../../assets/email-wide-hero.jpg" /></div>
                    </div>

                    <section class="siteSection">
                        <h2 class="text-primary">NEW</h2>

                        <div class="row mt-2">
                            <div class="col-12">
                                <p class="mt-3"><strong>See pinned notes for your Customers. </strong> Customer pinned
                                    notes will now pop up on ROs and Appointments so you can give your customers a more
                                    personal
                                    experience. (Click anywhere to hide pinned note popups.)</p>
                            </div>
                            <div class="col-12 mt-4">
                                <div class="gifWrapper"><img alt="" src="https://i.imgur.com/m616JgV.gif" /></div>
                            </div>
                            <div class="col-12">
                                <p class="mt-3"><strong>Edit Service notes as a Technician. </strong> Technicians can
                                    now
                                    take notes on their assigned Services to communicate important information back to
                                    the
                                    office. (These notes are internal-facing, and will not appear on customer Estimates
                                    or
                                    Invoices.)</p>
                            </div>
                            <div class="col-12 mt-4">
                                <div class="gifWrapper"><img alt="" src="https://i.imgur.com/0hD1tT2.gif" /></div>
                            </div>
                            <div class="col-12">
                                <p class="mt-3"><strong>View Item Descriptions as a Technician. </strong> Important
                                    information saved in the Item Description (e.g. parts numbers) are now viewable on
                                    the
                                    technician app. </p>
                            </div>
                            <div class="col-12 mt-4">
                                <div class="gifWrapper"><img alt="" src="https://i.imgur.com/klqJKhy.png" /></div>
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col-12">
                                <h2 class="text-primary">IMPROVEMENTS</h2>
                            </div>
                            <div class="col-12">
                                <p class="mt-3 mb-0"><strong>See more relevant information. </strong>
                                </p>

                                <ul class="fixesList mb-0 mt-2">
                                    <li>
                                        <p>On the Work Board > List view, you will now see only Active orders by default
                                            to
                                            avoid clutter
                                        </p>
                                    </li>
                                    <li>
                                        <p>In the global search bar, search results will no longer display past
                                            Appointments
                                            or
                                            Archived ROs
                                        </p>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-12">
                                <p class="mt-3 mb-0"><strong>Work better on the Calendar screen.
                                    </strong>
                                </p>

                                <ul class="fixesList mb-0 mt-2">
                                    <li>
                                        <p>Appointments can now be created without Vehicles
                                        </p>
                                    </li>
                                    <li>
                                        <p>You can now stay on your keyboard to pick a date in an Appointment window
                                        </p>
                                    </li>
                                    <li>
                                        <p>You will now be asked for confirmation when deleting Appointments
                                        </p>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-12 mt-4">
                                <div class="gifWrapper"><img alt="" src="https://i.imgur.com/4XTXPsv.gif" /></div>
                            </div>



                            <div class="col-12">
                                <p class="mt-3 mb-0"><strong>More intuitive Technician app.
                                    </strong>
                                </p>

                                <ul class="fixesList mb-0 mt-2">
                                    <li>
                                        <p>Appointments are now sorted reverse-chronologically, with upcoming
                                            Appointments
                                            at
                                            the top

                                        </p>
                                    </li>
                                    <li>
                                        <p>The ‘Red’, ‘Yellow’ and ‘Green’ signals are now more sensitive and easier to
                                            press

                                        </p>
                                    </li>
                                    <li>
                                        <p>When an inspection is removed from a job in the office, the Technician app
                                            will
                                            update in real time
                                        </p>
                                    </li>
                                    <li>
                                        <p>If there are assigned but incomplete Services on an RO, a warning will be
                                            shown
                                            to
                                            office users if they flip the RO from Estimate to Invoice status
                                        </p>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-12 mt-4">
                                <div class="gifWrapper"><img alt="" src="https://i.imgur.com/jF1r11n.gif" /></div>
                            </div>



                            <div class="col-12">
                                <p class="mt-3 mb-0"><strong>Continuous improvement on the RO screen.

                                    </strong>
                                </p>

                                <ul class="fixesList mb-0 mt-2">
                                    <li>
                                        <p>Vehicles can now be changed on an RO even after it has been converted to
                                            Invoice
                                            status
                                        </p>
                                    </li>
                                    <li>
                                        <p>Items with long names will now be fully visible across multiple lines on the
                                            RO
                                            screen
                                        </p>
                                    </li>
                                    <li>
                                        <p>You will now be prompted to select an Item before being allowed to edit the
                                            Description, Quantity, or Price
                                        </p>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-12 mt-4">
                                <div class="gifWrapper"><img alt="" src="https://i.imgur.com/HcLTRQA.gif" /></div>
                            </div>


                            <div class="col-12 mt-4">
                                <h2 class="text-primary">FIXES</h2>

                                <ul class="fixesList mt-2 mb-0">
                                    <li>
                                        <p>Fixed a bug that sometimes caused Items from one Service to get duplicated
                                            onto
                                            another Service when assigning technicians </p>
                                    </li>
                                    <li>
                                        <p>When dragging Appointments in the Calendar, the hover box will no longer
                                            leave a
                                            trail across your screen
                                        </p>
                                    </li>
                                    <li>
                                        <p>From the Item Description field in an RO, shift-tabbing will now take you
                                            back to
                                            the
                                            Item Name instead of the Item Type
                                        </p>
                                    </li>
                                    <li>
                                        <p>Display Names will auto-generate when creating a new customer from the RO
                                            screen
                                        </p>
                                    </li>
                                    <li>
                                        <p>Fixed a bug where Customer names were not pre-populating when creating a new
                                            Customer
                                            and Vehicle using the “+” button to the right of the global search
                                        </p>
                                    </li>
                                    <li>
                                        <p>Fixed a bug that sometimes prevented RO drag-and-drop from working right
                                            after a
                                            new
                                            column is added to the Kanban board
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            Fixed a bug which locked Kanban board columns and caused new Estimates to
                                            disappear
                                            if
                                            immediately dragged within the Estimate column following creation (happened
                                            only
                                            Oct
                                            19)
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="btnWrapper text-center my-5"><a class="btn-primary btn-lg"
                                href="https://app.myautoleap.com/">Login </a></div>
                    </section>
                </div>

                <div class="footer">
                    <p>&copy; AutoLeap Inc., 2020. All rights reserved.</p>
                </div>
            </div>
        </div>
    </main>
</div>